module.exports = __webpack_public_path__ + "static/media/yokohama_banner.4c128f5d.png";